<p>
  auto-generated works!
</p>
